import LoadPanel, {Position} from "devextreme-react/load-panel";

export default function LoadPagePanel(props: { visible: boolean }) {
  return (
    <LoadPanel visible={props.visible} container={'.dx-drawer-content .dx-scrollable-container'} >
      <Position my="center" at="center" of=".dx-drawer-content .dx-scrollable-container" />
    </LoadPanel>
  )
}
